import { colorsPalettes, mixins, rgba } from "@similarweb/styles";
import styled from "styled-components";
import { ClosableItemColorMarker } from "app/components/compare/StyledComponent";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const TableCellStyle = styled.div`
    display: flex;
    align-items: center;
`;

const TableRowStyle = styled(FlexRow)`
    font-weight: 400;
    font-style: normal;
    font-size: 14px;
    letter-spacing: 0.6px;
    padding-bottom: 4px;
    line-height: 24px;
    justify-content: space-between;
`;

export const TableSubtitle = styled(TableRowStyle)`
    ${mixins.setFontVariant("caption", colorsPalettes.carbon["400"])};
    padding-bottom: 12px;
`;

export const TableCellDomainMarker = styled(ClosableItemColorMarker)<{ background: string }>`
    position: static;
    background-color: ${(p) => p.background};
    margin: 0 8px 0 0;
    flex-shrink: 0;
    width: 10px;
    height: 10px;
`;

export const TableCellDomainName = styled.div`
    ${mixins.setFontVariant("body2")};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 230px;
`;

const TooltipContainer = styled(FlexColumn)<{ width: string }>`
    justify-content: flex-start;
    box-sizing: border-box;
    padding: 12px 16px 0 16px;
    background-color: ${colorsPalettes.carbon[0]};
    box-shadow: 0 3px 6px 0 ${rgba(colorsPalettes.carbon[200], 0.5)};
    border-radius: 5px;
    width: ${({ width }) => width};
    color: ${rgba(colorsPalettes.carbon[500], 0.8)};
`;

export interface IPoint {
    color: string;
    name: string;
    numberOfKeywords: number;
    percentageFromTotal: number;
    change: number;
}

interface IChannelsOverviewBarChartTooltipProps {
    children: React.ReactNode;
    width: string;
}

export const ChannelsOverviewChartTooltip = ({ children, width }: IChannelsOverviewBarChartTooltipProps) => {
    return <TooltipContainer width={width}>{children}</TooltipContainer>;
};
